import { IntlShape } from 'react-intl';
import * as Yup from 'yup';

import { PhoneUtils } from '../../../../../common/helpers/phone';
import { InputNumberFormState } from './types';

export const errorMessages = {
  required: {
    id: 'text-this-field-is-required',
    defaultMessage: 'This field is required',
  },
  invalidPhone: {
    id: 'text-enter-valid-phone-number',
    defaultMessage: 'Please enter a valid phone number',
  },
  hasBeenVerified: {
    id: 'text-has-been-verified',
    defaultMessage: 'This number has been verified',
  },
} as const;

export const inputNumberValidationSchema = (
  formatMessage: IntlShape['formatMessage']
) =>
  Yup.object().shape({
    callingCode: PhoneUtils.callingCodeValidation(formatMessage),
    phone: PhoneUtils.phoneValidation(formatMessage),
  });

export const defaultInputNumberFormState: InputNumberFormState = {
  callingCode: '',
  phone: '',
  optIn: true,
  isEditable: true,
} as const;
